import React from 'react';
import './Home.css';

const Home: React.FC = () => {
    return (
        <main id="main" className='container'>
            <div className="home-main">
                Home...
            </div>
        </main>
    );
};

export default Home;
